import { Grid, Typography } from "@mui/material";
import { Organization } from "src/store/reducers/organizations/organizationsApiSlice";
import useStyles from "./OrgIcon.styles";

interface OrgIconProps {
  organization?: Organization;
}

const OrgIcon = ({ organization }: OrgIconProps) => {
  const classes = useStyles();

  return (
    <Grid item className={classes.orgIcon}>
      <Typography
        variant="caption"
        textTransform="uppercase"
        color="white"
        fontSize="18px"
        fontWeight="bold"
      >
        {organization ? organization.name[0] : "O"}
      </Typography>
    </Grid>
  );
};

export default OrgIcon;
